var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        }
      }),
      _vm._v(" "),
      _vm.persona
        ? _c(
            "v-card",
            { staticClass: "p-0" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { shrink: "" } },
                        [
                          _c(
                            "v-avatar",
                            {
                              attrs: {
                                size: 100,
                                color: _vm.persona.foto
                                  ? "#FFF"
                                  : "light-blue darken-4"
                              }
                            },
                            [
                              _vm.persona.foto
                                ? _c("img", {
                                    staticStyle: {
                                      border: "1px solid #7BAFD4 !important"
                                    },
                                    attrs: {
                                      src: _vm.url_backend + _vm.persona.foto,
                                      alt: _vm.persona.nombres[0]
                                    },
                                    on: {
                                      error: function($event) {
                                        return _vm.handleImageError()
                                      }
                                    }
                                  })
                                : _c(
                                    "span",
                                    { staticClass: "white--text headline" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.persona.nombres[0] || "-")
                                      )
                                    ]
                                  )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "text-xs-center", attrs: { grow: "" } },
                        [
                          _c("b", { staticClass: "blue--text" }, [
                            _vm._v("NOMBRE: ")
                          ]),
                          _vm._v(
                            _vm._s(_vm.persona.ap_paterno) +
                              "\n          " +
                              _vm._s(_vm.persona.ap_materno) +
                              " " +
                              _vm._s(_vm.persona.nombres) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("b", { staticClass: "blue--text" }, [
                            _vm._v("NRO DOCUMENTO: ")
                          ]),
                          _vm._v(_vm._s(_vm.persona.nro_doc) + "\n          "),
                          _c("br"),
                          _vm._v(" "),
                          _c("b", { staticClass: "blue--text" }, [
                            _vm._v("ITEM: ")
                          ]),
                          _vm._v(
                            _vm._s(_vm.persona.movilidad.nro_item) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("b", { staticClass: "blue--text" }, [
                            _vm._v("UNIDAD: ")
                          ]),
                          _vm._v(
                            _vm._s(_vm.persona.movilidad.nombre_unidad) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f1d7e2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1d7e2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/tipificacion/components/DatosPersonales.vue
// module id = null
// module chunks = 